/**
 * Central SEO config used by every public page (homepage, pricing, landing pages, samples).
 * Edit SITE_DOMAIN in env or here when production domain is finalised.
 */

export const SITE_DOMAIN =
  process.env.REACT_APP_SITE_DOMAIN || "https://invoicesetu.in";

export const BRAND = {
  name: "InvoiceSetu",
  legalName: "InvoiceSetu",
  tagline: "India's Smart Invoice Software for Small Businesses",
  defaultDescription:
    "Create GST invoices, quotations, e-bills and credit notes in minutes. Free invoice generator for Indian businesses, freelancers, traders, shop owners and CAs. Setup in 2 minutes — no credit card.",
  twitter: "@invoicesetu",
  logo: `${SITE_DOMAIN}/assets/logo.png`,
};

export const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: BRAND.legalName,
  url: SITE_DOMAIN,
  logo: BRAND.logo,
  sameAs: [
    "https://twitter.com/invoicesetu",
    "https://www.linkedin.com/company/invoicesetu",
  ],
};

export const SOFTWARE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: BRAND.name,
  operatingSystem: "Web, Android, iOS",
  applicationCategory: "BusinessApplication",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "INR",
    description: "Free plan available with no credit card",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.9",
    reviewCount: "327",
  },
  description: BRAND.defaultDescription,
  url: SITE_DOMAIN,
};

export const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: BRAND.name,
  url: SITE_DOMAIN,
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_DOMAIN}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export const buildBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, idx) => ({
    "@type": "ListItem",
    position: idx + 1,
    name: item.name,
    item: item.url.startsWith("http") ? item.url : `${SITE_DOMAIN}${item.url}`,
  })),
});

export const buildFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
